import { render } from "./ServicePreview.vue?vue&type=template&id=88665c46&scoped=true"
import script from "./ServicePreview.vue?vue&type=script&lang=js"
export * from "./ServicePreview.vue?vue&type=script&lang=js"

import "./ServicePreview.vue?vue&type=style&index=0&id=88665c46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88665c46"]])

export default __exports__